/**
 * Capa de Acceso a Datos (Data Access Logic - DL) para la dinámica "Light Show Pro".
 * Gestiona las peticiones HTTP (fetch) hacia el controlador LightShowController de la API.
 */

const Prepare = async (beatsPerMinute, framesSequence) => {
    try {
        // Preparamos el objeto con los datos exactos que espera el DTO en C#
        const dataToSend = {
            beatsPerMinute: beatsPerMinute,
            frames: framesSequence // Enviamos el arreglo de cuadros de animación
        }
        
        // Apuntamos al nuevo controlador exclusivo que creamos para el Light Show
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/prepare`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP (Ej. 400 Bad Request, 500 Internal Server Error)
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible enviar la configuración de los frames al servidor. Intenta nuevamente.' 
            }
        }
        
        const data = await response.json()
        
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar conectar con el servidor para preparar el show.' }
    }
}

const Start = async (beatsPerMinute, framesSequence) => {
    try {
        const dataToSend = {
            beatsPerMinute: beatsPerMinute,
            frames: framesSequence
        };

        // Para Iniciar, no enviamos Body, ya que el servidor calculará el Timestamp exacto de arranque.
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/start`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible arrancar el show de luces.' 
            }
        }
        
        const data = await response.json()
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar iniciar el show de luces.' }
    }
}

const Stop = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/stop`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        
        if (!response.ok) {
            const errorData = await response.json()
            return { 
                success: false, 
                message: errorData.message || 'No ha sido posible detener la dinámica.' 
            }
        }
        
        const data = await response.json()
        return { success: true, data: data }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar conectar con el servidor para detener el show.' }
    }
}

const GetAllPresets = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/presets`);
        if (!response.ok) throw new Error('Error al obtener presets');
        const data = await response.json();
        return { success: true, data: data };
    } catch (error) {
        return { success: false, message: 'Error de red al cargar los presets de la base de datos.' };
    }
}

const CreatePreset = async (name, bpm, framesSequence) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/presets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: name, beatsPerMinute: bpm, framesJson: JSON.stringify(framesSequence) })
        });
        const data = await response.json();
        return { success: response.ok, data: data.data, message: data.message };
    } catch (error) {
        return { success: false, message: 'Error de red al crear el preset.' };
    }
}

const UpdatePreset = async (id, name, bpm, framesSequence) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/presets/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: name, beatsPerMinute: bpm, framesJson: JSON.stringify(framesSequence) })
        });
        const data = await response.json();
        return { success: response.ok, message: data.message };
    } catch (error) {
        return { success: false, message: 'Error de red al actualizar el preset.' };
    }
}

const DeletePreset = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}LightShow/presets/${id}`, {
            method: 'DELETE'
        });
        const data = await response.json();
        return { success: response.ok, message: data.message };
    } catch (error) {
        return { success: false, message: 'Error de red al eliminar el preset.' };
    }
}

export { Prepare, Start, Stop, GetAllPresets, CreatePreset, UpdatePreset, DeletePreset };